exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{background-color:white;padding:24px}h1{font-weight:bold}select{margin-left:5px;padding:5px;border-color:var(--accent-color);border-radius:5px;color:var(--accent-color);font-weight:bold}\n", ""]);

// exports
